module.exports = __webpack_public_path__ + "static/media/pbb_back.7f001773.svg";